'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = timeUpdateLoopingListener;

var _actions = require('../../store/actions');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * When the volume changes. We optimistically update through the
 * `updateState` call. But the listener is here to make sure the
 * volume changes are in sync between our stateful store and the
 * non-stateful video.
 *
 * So here we just update video muted & volume. Ideally it's always
 * a no-op.
 */
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule loopListener
 * 
 */

function timeUpdateLoopingListener(state, next, playerId) {
  var storeState = _store2.default.storeInstance().getState();
  var currentTimeMs = _store2.default.getPlayerInstance(playerId).currentTime * 1000;
  var loop = storeState.players[playerId].loop;

  if (loop && loop.get('isLooping') && (currentTimeMs > loop.get('endTimeMs') || currentTimeMs < loop.get('startTimeMs'))) {
    _store2.default.storeInstance().dispatch((0, _actions.setCurrentTimeMs)(playerId, loop.get('startTimeMs')));
  }
}
module.exports = exports['default'];